<script>
  //全局路径
  var globalPath = {
    api: "/api/", //主页调用接口地址
    downlaod: "/template/", //静态资源模版下载
    app: "/app/", //静态资源模版下载
    h5pay: "/h5pay/", //主页调用接口地址
    url:'/url/'
  };
  // let path;
  // console.log(process.env)
  // if (process.env.NODE_ENV === "development") {
  //   // dev
  //   path = "/base/"; //登陆页面接口地址
  // } else {
  //   // build
  //   path = "/login/"; //登陆页面接口地址
  // }


  //获取各打包环境地址，并拼接
  if(process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'presentation'){
    globalPath.url = '/signIn/';
    for(let key in globalPath){
      globalPath[key] = process.env.API_ROOT + globalPath[key];
    }
  }
  
  
  console.log(globalPath)
  export default {
    globalPath
  };
</script>



// WEBPACK FOOTER //
// src/assets/script/globalPath.vue